import { LANDING_PACKAGES, getLandingPackageId } from "@/cart/landingPackage";

/**
 * Lines that went into the cart together as one offer: a landing-page
 * package. The cart draws it as one item led by its robot, and every line in
 * it holds the same count.
 */
export type CartBundle = {
  /** Distinct per bundle, so two kinds never group together. */
  key: string;
  name: string;
  note: string;
  href: string;
  includesMaticCare: boolean;
  /** Re-stamped on the cart when an undo puts the bundle back; null if none. */
  cartAttributes: Record<string, string> | null;
};

type LineWithAttributes = Parameters<typeof getLandingPackageId>[0];

export const getCartBundle = (line: LineWithAttributes): CartBundle | null => {
  const packageId = getLandingPackageId(line);
  if (packageId === null) return null;

  return {
    key: `package:${packageId}`,
    ...LANDING_PACKAGES[packageId],
    includesMaticCare: false,
    // The page and UTM stamps stay on the cart when lines are removed.
    cartAttributes: null,
  };
};
